import { ESPLIT_BY_THREE_REGEX } from './regex';
export const splitPriceByThree = (price) => {
  const priceStr = price !== undefined ? price.toString() : '0';
  const count = priceStr.length;
  if (count <= 3) return priceStr;
  const firstCharsLength = count % 3;
  const restArray = priceStr
    .slice(firstCharsLength)
    .match(ESPLIT_BY_THREE_REGEX);
  const firstChars = priceStr.slice(0, firstCharsLength);
  if (!firstChars) return restArray.join(',');
  return firstChars + ',' + restArray.join(',');
};
